import ChartTypeSelector from './ChartTypeSelector';
import { useChartContext } from '../ChartContext';
import {
  ExpressionModeKey,
  TimeUnit,
} from '../../../utils/apollo/graphqlSchema';

const ChartTypeSelectorController = () => {
  const {
    metadata: { query, timeUnit },
  } = useChartContext();

  const isHistogram =
    'expressionMode' in query &&
    query.expressionMode.key === ExpressionModeKey.Histogram &&
    timeUnit === TimeUnit.AllTime;

  // no need to display in histogram since it's only option
  // in our code, isHistogram is defined in common.ts, it means ALlTime + Histogram mode in Builder.
  if (isHistogram) {
    return null;
  }

  return <ChartTypeSelector />;
};

export default ChartTypeSelectorController;
